import React from "react";
import "./styles.scss";

interface IProps {
  title: string;
  onClick(): void;
}

const SubSectionCard = (props: IProps) => {
  return (
    <div className="student-subsection-card" onClick={props.onClick}>
      <div className="title">
        <h3 style={{ fontWeight: 700, color: "#6b6969" }}>{props.title}</h3>
      </div>
    </div>
  );
};

export default SubSectionCard;
